module.exports = __webpack_public_path__ + "static/webinar-banner-5f3b9aad1d34713355e9d9ed4f0360f0.webp";